import { render, staticRenderFns } from "./AdditionalResourcesModal.vue?vue&type=template&id=7b65720f&scoped=true&"
import script from "./AdditionalResourcesModal.vue?vue&type=script&lang=js&"
export * from "./AdditionalResourcesModal.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalResourcesModal.vue?vue&type=style&index=0&id=7b65720f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b65720f",
  null
  
)

export default component.exports